export enum RateNP {
    I = 'I',
    II = 'II'
}